window.addEventListener('load', function() {
    const apiHost = 'vacancy-api.subway.ru';
    const $role = $('#select-role');
    const $city = $('#select-city');
    const $storeList = $('#store-list');
    const $storeInfo = $('#store-info');
    const dict = {
        cityStores: [],
        storeList: {}
    };



    const MIN_STORE_COUNT = 5;

    const getStoresByCityId = function(cityId) {
        return new Promise((resolve) => $.get(`https://${apiHost}/store/?cityId=${cityId}`, (data) => {
            dict.cityStores = data;
            resolve(data);
        }));
    }

    const getVacancyByCityId = function(cityId) {
        return new Promise((resolve) => $.get(`https://${apiHost}/vacancy/?cityId=${cityId}`, resolve));
    }

    const rolePromise = new Promise((resolve, reject) => {
        $.get(`https://${apiHost}/vacancy/categories`, resolve);
    });

    const cityPromise = new Promise((resolve, reject) => {
        $.get(`https://${apiHost}/city`, resolve)
    });

    const mapPromise = new Promise((resolve) => ymaps.ready(resolve));

    function refreshDropdowns() {
        $role.prop('disabled', parseInt($city.val()) === 0);
    }

    function showStoreList() {
        $storeList.show();
        $storeInfo.hide();

        dict.currentStore = null;

        $('.map-overlay').removeClass('store').addClass('list');
        $('.store-items-list', $storeList).html('');

        for (const {store, vacancy} of Object.values(dict.storeList)) {
            const role = dict.roles.find(({id}) => id === vacancy.vacancy_id);
            const key = `${store.id}-${vacancy.vacancy_id}`;
            const $template = $($('#store-list-item').html()).clone();

            $('.address', $template).html(store.address);
            $('.vacancy-role', $template).html(role.title);

            $('.store-items-list').append($template);

            $template.on('click', () => {
                drawStoreData(store, vacancy);
            });

            $('.store-list-item-close', $template).on('click', (e) => {
                e.stopPropagation();

                delete dict.storeList[key];

                showStoreList();
            });
        }
    }

    function drawStoreData(store, vacancy) {
        const role = dict.roles.find(({id}) => id === vacancy.vacancy_id);

        $('.map-overlay').removeClass('list').addClass('store');

        $('#store-info .address').html(store.address);
        $('#store-info .requirements').html(vacancy.requirementsHtml);
        $('#store-info .responsibility').html(vacancy.responsibilityHtml);
        $('#store-info .conditions').html(vacancy.conditionsHtml);

        if (vacancy.contacts) {
            $('#store-info .contacts').prev('h4').show();
            $('#store-info .contacts').html(vacancy.contactsHtml);
        } else {
            $('#store-info .contacts').prev('h4').hide();
        }

        $('#store-info .vacancy-title').html(role.title);

        const key = `${store.id}-${vacancy.vacancy_id}`;

        dict.currentData = {store, vacancy};

        $('#store-info button').html(dict.storeList[key] ? 'Заполнить анкету' : 'Добавить ресторан в список');

        $storeList.hide();
        $storeInfo.css('display', 'flex');
        $('.map-overlay-content').scrollTop(0);
    }

    $('#store-info .close').on('click', () => showStoreList());

    $('#store-info button').on('click', () => {
        const key = `${dict.currentData.store.id}-${dict.currentData.vacancy.vacancy_id}`;

        if (!dict.storeList[key]) {
            dict.storeList[key] = Object.assign({}, dict.currentData);
        } else {
            window.location.href =  '#vacancies-new-form';
        }

        showStoreList();
    });

    Promise.all([rolePromise, cityPromise, mapPromise])
        .then(([roles, cities]) => {
            dict.roles = roles;
            dict.cities = cities;

            dict.roles.forEach(({id, title}) => $role.append(`<option value="${id}">${title}</option>`));
            dict.cities.forEach(({id, title}) => $city.append(`<option value="${id}">${title}</option>`));
        })
        .then(() => {
            const url = new URL(document.location.href);
            let selectedCityId = url.searchParams.get('city_id');
            const selectedCityName = url.searchParams.get('city_name');

            if (selectedCityName) {
                const city = dict.cities.find(({title}) => title === selectedCityName);

                if (city) {
                    selectedCityId = city.id;
                }
            }

            if (selectedCityId) {
                const option = $city.find(`option[value="${selectedCityId}"]`);

                if (option) {
                    $(option.get(0)).prop('selected', true);
                }
            }

            const selectedRoleId = url.searchParams.get('category_id');

            if (selectedRoleId) {
                const option = $role.find(`option[value="${selectedRoleId}"]`);

                if (option) {
                    $(option.get(0)).prop('selected', true);
                }
            }

            if (selectedCityId) {
                const city = dict.cities.find(({id}) => id === parseInt(selectedCityId));

                return ymaps.geocode(city.title, {results: 1, kind: 'locality'}).then((res) => {
                    const result = res.geoObjects.get(0);

                    if (result) {
                        return result.geometry.getCoordinates();
                    }
                });
            } else {
                return ymaps.geolocation.get({provider: 'yandex'}).then((res) => {
                    const result = res.geoObjects.get(0);

                    if (result) {
                        const coordinates = result.geometry.getCoordinates();

                        return ymaps.geocode(coordinates, {results: 1, kind: 'locality'}).then((res) => {
                            const result = res.geoObjects.get(0);

                            if (result) {
                                const city = dict.cities.find(({title}) => title === result.properties.get('name'));

                                if (city) {
                                    const option = $city.find(`option[value="${city.id}"]`);

                                    if (option) {
                                        $(option.get(0)).prop('selected', true);
                                    }

                                    return coordinates;
                                }
                            }
                        });
                    }
                });
            }
        })
        .then((coordinates) => {
            const map = new ymaps.Map("store-map", {
                center: coordinates || [59.939095, 30.315868],
                zoom: 11,
                controls: ['zoomControl']
            });

            if ($('#map-search').length > 0) {
                const suggest = new ymaps.SuggestView('map-search', {
                    provider: {
                        suggest:(function(request, options){
                            let cityTitle = '';

                            const cityId = parseInt($city.val());

                            if (cityId) {
                                const city = dict.cities.find(({id}) => id === cityId);
                                cityTitle = city.title
                            }

                            const query = [cityTitle, request].filter((str) => str).join(', ');

                            return ymaps.suggest(query);
                        })
                    }
                });

                suggest.events.add('select', (event) => {
                    drawMap(event.originalEvent.item.value);
                });
            }

            const mapStoreCollection = new ymaps.GeoObjectCollection(null, {
                iconLayout: 'default#image',
                iconImageHref: '/local/templates/subwork/img/place.svg',
                iconImageSize: [28, 40],
                iconImageOffset: [-14, -40],
            });

            function drawMap(query) {
                let zoomMargin = [50, 400, 50, 50];

                if ($('body').width() < 600) {
                    zoomMargin = [0, 0, 0, 0]
                }

                if (query) {
                    return ymaps.geocode(query, {results: 1}).then((res) => {
                        const result = res.geoObjects.get(0);

                        if (result) {
                            map.setCenter(result.geometry.getCoordinates(), 15);
                        }
                    });
                }

                const cityId = parseInt($city.val());
                const roleId = parseInt($role.val());

                if (cityId > 0) {
                    const dataPromise = Promise.all([
                        getStoresByCityId(cityId),
                        getVacancyByCityId(cityId)
                    ]);

                    const city = dict.cities.find(({id}) => id === cityId);

                    mapStoreCollection.removeAll();

                    ymaps.geocode(city.title, {results: 1}).then((res) => {
                        const result = res.geoObjects.get(0);

                        if (result) {
                            let promise = Promise.resolve();

                            return map.setCenter(result.geometry.getCoordinates())
                                .then(() => dataPromise)
                                .then(([stores, vacancies]) => {
                                    let isStoreSelect = false;

                                    const url = new URL(document.location.href);
                                    const storeIdsWithVacancies = vacancies
                                        .filter(({vacancy_id}) => vacancy_id === roleId)
                                        .map(({store_id}) => store_id);

                                    stores
                                        .filter(({id}) => storeIdsWithVacancies.includes(id))
                                        .forEach((store) => {
                                            const {id, geo_lat, geo_lng} = store;

                                            isStoreSelect = parseInt(url.searchParams.get('store_id')) === parseInt(store.id);

                                            if (geo_lat && geo_lng) {
                                                const placemark = new ymaps.Placemark([parseFloat(geo_lat), parseFloat(geo_lng)]);

                                                placemark.events.add('click', () => {
                                                    drawStoreData(store, vacancies.find(({store_id, vacancy_id}) => store_id === id && roleId === vacancy_id));
                                                });

                                                mapStoreCollection.add(placemark);

                                                if (isStoreSelect) {
                                                    placemark.events.fire('click');
                                                    $('#store-info button').trigger('click');
                                                    placemark.events.fire('click');

                                                    const coords = placemark.geometry.getCoordinates();

                                                    promise = map.setBounds([coords, coords], {zoomMargin}).then(() => {
                                                        if (map.getZoom() > 15) {
                                                            map.setZoom(15);
                                                        }
                                                    });
                                                }
                                            }
                                        });

                                    if (isStoreSelect) {
                                        return promise;

                                    } else {
                                        return map.setBounds(mapStoreCollection.getBounds(), {zoomMargin}).then(() => {
                                            if (map.getZoom() > 15) {
                                                map.setZoom(15);
                                            }
                                        });
                                    }
                                });
                        }
                    });
                }
            }

            map.geoObjects.add(mapStoreCollection);

            $role.on('change', () => {
                dict.storeList = {};
                showStoreList();
                drawMap();
            });

            $city.on('change', () => {
                dict.storeList = {};
                refreshDropdowns();
                showStoreList();
                drawMap();
            });

            const dropdownOptions = {
                width: "100%",
                theme: "classic"
            };

            $role.select2(dropdownOptions);
            $city.select2(dropdownOptions);

            refreshDropdowns();
            return drawMap();
        });

        let formSended = false;

        $('#vacancies-new-form').on('submit', (e) => {
            e.preventDefault();

            $('#form-error').hide();

            const sendForm = (json) => {
                formSended = true;
                $('.form__submit.js-anketa-send[type=submit]').addClass('in-process');

                $.post(`https://${apiHost}/vacancy/response`, json, (res) => {
                    $('.form__submit.js-anketa-send[type=submit]').removeClass('in-process');
                    const errors = [];

                    if (res === true) {
                        $('#vacancies-new-form').hide();
                        $('#form-success').show();
                        $('.map-container').addClass('lock');
                        $role.prop('disabled', true);
                        $city.prop('disabled', true);
                    } else {
                        formSended = false;

                        Object.values(res).forEach((errs) => errors.push(...errs));

                        $('#form-error').html(errors.join("<br/>"));
                        $('#form-error').show();
                    }
                });
            };

            if (!formSended) {
                const isBigCity = Object.values(dict.cityStores).length > MIN_STORE_COUNT;
                const entries = $('#vacancies-new-form').serializeArray();
                const json = {
                    city_id: parseInt($city.val()),
                    vacancy_id: parseInt($role.val()),
                    stores: Object.values(dict.storeList).map(({store, vacancy}) => store.id)
                };

                entries.forEach(({name, value}) => json[name] = value);

                const errors = [];

                if (json.vacancy_id === 0) {
                    errors.push('Выберите вакансию в выбранном городе.');
                }

                if (json.stores.length === 0 && isBigCity) {
                    errors.push('Необходимо выбрать рестораны для отправки анкеты.');
                }

                if (errors.length > 0) {
                    $('#form-error').html(errors.join("<br/>"));
                    $('#form-error').show();

                    return;
                }

                if (json.stores.length === 0 && !isBigCity) {
                    $('#form-confirmation').show();

                    $('#form-confirmation #confirm-yes').on('click', () => {
                        $('#form-confirmation #confirm-yes').off('click');

                        sendForm(json);
                        $('#form-confirmation').hide();
                    });

                    $('#form-confirmation #confirm-no').on('click', () => {
                        $('#form-confirmation #confirm-no').off('click');

                        window.scrollTo(0, 0);
                        $('#form-confirmation').hide();
                    });

                } else {
                    sendForm(json);
                }
            }
        });
});


